import _ from 'lodash';
import { useEffect, useState } from 'react';
import safeAreaInsets from 'safe-area-insets';
import { Except } from 'type-fest';

export type Insets = Except<
  typeof safeAreaInsets,
  'onChange' | 'offChange'
>;

export default function useSafeAreaInsets(): Insets {
  const [insets, setInsets] = useState(
    _.omit(safeAreaInsets, ['onChange', 'offChange'])
  );

  useEffect(() => {
    const update = (newInsets: Partial<Insets>) =>
      setInsets(s => ({ ...s, ...newInsets }));
    safeAreaInsets.onChange(update);
    return () => safeAreaInsets.offChange(update);
  }, []);

  return insets;
}
